document.addEventListener('DOMContentLoaded', function () {
    var allAreaSections = document.querySelectorAll("section[id^='inquiry--result-area-']");

    if (allAreaSections) {
        // #region Area section control

        var currentArea = -1; // Always start at summary

        var resultSectionContainer = document.querySelector('#inquiry--result-section-container');
        var summarySection = document.querySelector('#inquiry--result-summary');
        var summaryButton = document.querySelector('#inquiry--result-navigation-summary');
        var forwardButton = document.querySelector('#inquiry--result-navigation-forward');
        var backwardButton = document.querySelector('#inquiry--result-navigation-backward');
        var summaryAreaButtons = document.querySelectorAll('.inquiry--result-content-title-button');
        var resultNavigationSelect = document.querySelector('#inquiry--result-navigation-select');
        var summaryResultNavigationSelect = document.querySelector(
            '#inquiry--result-summary-navigation-select'
        );

        if (forwardButton && backwardButton && summaryButton) {
            window.addEventListener('popstate', (e) => {
                e.preventDefault();
                e.stopPropagation();

                var areaIndex = e.state.currentArea;

                goToStep(areaIndex);
            });

            var setSummaryButton = (state) => {
                if (state === true) {
                    summaryButton.disabled = false;
                    summaryButton.classList.remove('d-none');
                    summaryButton.classList.add('d-flex');
                } else {
                    summaryButton.disabled = true;
                    summaryButton.classList.add('d-none');
                    summaryButton.classList.remove('d-flex');
                }
            };

            if (summaryAreaButtons && summaryAreaButtons.length > 0) {
                for (var i = 0; i < summaryAreaButtons.length; i++) {
                    summaryAreaButtons[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        var areaSectionId = parseInt(
                            e.target.closest('.inquiry--result-content-title-button').dataset
                                .areaIndex
                        );

                        if (areaSectionId === null || areaSectionId === undefined) return;
                        window.history.pushState({ currentArea: areaSectionId }, '');

                        goToStep(areaSectionId);
                    });
                }
            }

            var goToStep = (stepIndex) => {
                if (currentArea >= 0) {
                    hideAllAreaBacktracks(allAreaSections[currentArea]);
                    allAreaSections[currentArea].classList.remove('show-area');
                } else {
                    summarySection.classList.add('d-none');
                }

                if (stepIndex >= 0) {
                    allAreaSections[stepIndex].classList.add('show-area');
                } else {
                    summarySection.classList.remove('d-none');
                }

                currentArea = stepIndex;

                resultNavigationSelect.value = currentArea;
                summaryResultNavigationSelect.value = currentArea;

                resultSectionContainer.scrollIntoView();

                document.removeEventListener('click', hideBacktrackOnOutsideClick);

                if (currentArea >= 0) {
                    if (backwardButton.disabled) {
                        backwardButton.disabled = false;
                    }

                    if (summaryButton.disabled) {
                        setSummaryButton(true);
                    }

                    if (currentArea === allAreaSections.length - 1) {
                        forwardButton.disabled = true;
                    } else if (forwardButton.disabled) {
                        forwardButton.disabled = false;
                    }

                    if (resultNavigationSelect.classList.contains('d-none')) {
                        resultNavigationSelect.classList.remove('d-none');
                    }
                } else {
                    if (!backwardButton.disabled) {
                        backwardButton.disabled = true;
                    }

                    if (forwardButton.disabled) {
                        forwardButton.disabled = false;
                    }

                    if (!summaryButton.disabled) {
                        setSummaryButton(false);
                    }

                    if (!resultNavigationSelect.classList.contains('d-none')) {
                        resultNavigationSelect.classList.add('d-none');
                    }
                }
            };

            window.history.replaceState({ currentArea: currentArea }, '');

            forwardButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (currentArea + 1 < allAreaSections.length) {
                    window.history.pushState({ currentArea: currentArea + 1 }, '');

                    goToStep(currentArea + 1);
                }
            });
            backwardButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (currentArea - 1 >= -1) {
                    window.history.pushState({ currentArea: currentArea - 1 }, '');

                    goToStep(currentArea - 1);
                }
            });
            summaryButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                window.history.pushState({ currentArea: -1 }, '');

                goToStep(-1);
            });
            var navigationSelectEvent = (e) => {
                e.preventDefault();
                e.stopPropagation();

                var stepIndex = parseInt(e.target.value);

                window.history.pushState({ currentArea: stepIndex }, '');

                goToStep(stepIndex);
            };

            resultNavigationSelect.addEventListener('change', navigationSelectEvent);
            summaryResultNavigationSelect.addEventListener('change', navigationSelectEvent);
        }

        // #endregion

        // #region Backtrack control

        //
        var hideBacktrackOnOutsideClick = (e) => {
            if (!e.target.closest('.inquiry--area-result-backtrack')) {
                document.removeEventListener('click', hideBacktrackOnOutsideClick);
                hideAllAreaBacktracks(allAreaSections[currentArea]);
            }
        };

        var animateAndShowResultAnswers = (resultAnswerElement) => {
            resultAnswerElement.classList.remove('d-none');
            resultAnswerElement.classList.add('showing-result');

            document.removeEventListener('click', hideBacktrackOnOutsideClick);

            document.addEventListener('click', hideBacktrackOnOutsideClick);
        };

        var animateAndHideResultAnswers = (resultAnswerElement) => {
            resultAnswerElement.classList.add('d-none');

            document.removeEventListener('click', hideBacktrackOnOutsideClick);
        };

        /**
         * Hides all backtrack answers and shows backtrack option for a given area section
         */
        var hideAllAreaBacktracks = (areaSection) => {
            if (!areaSection) return;

            let areaBacktracks = areaSection.querySelectorAll('.inquiry--area-result-backtrack');

            if (!areaBacktracks || areaBacktracks.length === 0) return;

            for (let y = 0; y < areaBacktracks.length; y++) {
                var backtrackOptions = areaBacktracks[y].querySelectorAll(
                    '.inquiry--area-result-option-label-marker'
                );
                var backtrackAnswers = areaBacktracks[y].querySelector(
                    '.inquiry--area-result-answers'
                );

                if (!backtrackOptions || backtrackOptions.length === 0 || !backtrackAnswers)
                    continue;

                for (let i = 0; i < backtrackOptions.length; i++) {
                    backtrackOptions[i].classList.remove('d-none');
                }

                backtrackAnswers.classList.add('d-none');
            }
        };

        for (var x = 0; x < allAreaSections.length; x++) {
            // Add all backtrack event listeners

            var areaBacktracks = allAreaSections[x].querySelectorAll(
                '.inquiry--area-result-backtrack'
            );

            if (areaBacktracks && areaBacktracks.length > 0) {
                for (var i = 0; i < areaBacktracks.length; i++) {
                    areaBacktracks[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        var currentBacktrack = e.target.closest('.inquiry--area-result-backtrack');

                        var resultOptionLabelMarkers = currentBacktrack.querySelectorAll(
                            '.inquiry--area-result-option-label-marker'
                        );

                        var resultAnswers = currentBacktrack.querySelector(
                            '.inquiry--area-result-answers'
                        );

                        if (
                            !resultOptionLabelMarkers ||
                            resultOptionLabelMarkers.length === 0 ||
                            !resultAnswers
                        )
                            return;

                        if (resultOptionLabelMarkers[0].classList.contains('d-none')) {
                            // Hide answers, show option

                            for (let x = 0; x < resultOptionLabelMarkers.length; x++) {
                                resultOptionLabelMarkers[x].classList.remove('d-none');
                            }

                            animateAndHideResultAnswers(resultAnswers);
                        } else {
                            hideAllAreaBacktracks(
                                e.target.closest("section[id^='inquiry--result-area-']")
                            );

                            for (let x = 0; x < resultOptionLabelMarkers.length; x++) {
                                resultOptionLabelMarkers[x].classList.add('d-none');
                            }

                            animateAndShowResultAnswers(resultAnswers);
                        }
                    });
                }
            }
        }
        // #endregion

        // #region Highlight next button

        const setHighlightNextButton = (className) => {
            if (forwardButton.classList.contains(className)) return;

            forwardButton.classList.add(className);

            forwardButton.addEventListener(
                'click',
                (e) => {
                    forwardButton.classList.remove(className);
                    localStorage.setItem('hasSeenInquiryNextButtonHighlight', 'true');
                },
                { once: true }
            );
        };

        //var checkIfPrintMedia = window.matchMedia('print');

        if (
            forwardButton &&
            !localStorage.getItem('hasSeenInquiryNextButtonHighlight') &&
            window.innerWidth >= 768
        ) {
            // Only show highlight if user has not seen it before and is on desktop
            setHighlightNextButton('pulse-animate');
        }

        // #endregion
    }
});
